import { Params, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import { Action } from '@ngrx/store';
import { IconName } from '../../shared/components/icon/icon-data.generated';

export class PageFooterData {
  buttonText: string;
  iconName: IconName | null;
  route: string;
  elementId: string;

  constructor(buttonText: string, iconName: IconName | null, route: string, elementId: string | null = null) {
    this.buttonText = buttonText;
    this.iconName = iconName;
    this.route = route;
    this.elementId = elementId ?? 'footerBtn';
  }
}

export class PageHeaderData {
  pageHeaderText: string;
  pageSubtitleText?: string;
  route?: string;
  actionButton?: PageHeaderActionButton;

  constructor(
    pageHeaderText: string,
    pageSubtitleText?: string,
    route?: string,
    actionButton?: PageHeaderActionButton
  ) {
    this.pageHeaderText = pageHeaderText;
    this.pageSubtitleText = pageSubtitleText;
    this.route = route;
    this.actionButton = actionButton;
  }
}

export class PageHeaderActionButton {
  buttonText: string | null;
  buttonAction: Action;
  showMobile: boolean;
  disabledSelector?: (state: object) => boolean;
  elementId?: string;
  iconName?: IconName;
  ariaLabel?: string;

  constructor(
    buttonText: string | null,
    buttonAction: Action,
    disabledSelector?: (state: object) => boolean,
    elementId?: string,
    iconName?: IconName,
    showMobile?: boolean,
    ariaLabel?: string
  ) {
    this.buttonText = buttonText;
    this.buttonAction = buttonAction;
    this.disabledSelector = disabledSelector;
    this.elementId = elementId;
    this.iconName = iconName;
    this.showMobile = showMobile === undefined ? false : showMobile;
    this.ariaLabel = ariaLabel;
  }
}

export interface RouterStateUrl {
  url: string;
  params: Params;
  queryParams: Params;
  title: string;
  pageHeaderData: PageHeaderData;
  pageFooterData: PageFooterData;
}

export class CustomRouterStateSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams },
    } = routerState;
    const { params } = route;

    const title = route.data['title'];
    const pageHeaderData = route.data['pageHeaderData'];
    const pageFooterData = route.data['pageFooterData'];

    // Only return an object including the URL, params and query params
    // instead of the entire snapshot
    return { url, params, queryParams, title, pageHeaderData, pageFooterData };
  }
}
